import { useEffect, useState } from "react";

import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";

import api from "../../../services/api";

export const BalanceamentoDialog = ({ fetchData, metas = [], visible, dismiss, showError, showSuccess }) => {
    const [values, setValues] = useState({});

    useEffect(() => {
        let _values = {};
        metas.forEach((item) => {
            _values[item.id] = item.meta;
        });
        setValues(_values);
    }, [metas]);

    return (
        <Dialog
            header='Metas'
            footer={() => (
                <div>
                    <Button 
                        className="p-button-secondary"
                        label="Fechar"
                        onClick={dismiss}  
                    />
                </div>
            )}
            onHide={dismiss}
            visible={visible}
        >
            <div className="p-fluid">
                {metas.map((meta, index) => (
                    <div className="p-field p-col" key={index}>
                        <label htmlFor="a">{meta.setor_nome}</label>
                        <InputText 
                            onChange={e => setValues({...values, [meta.id] : e.target.value })}
                            onBlur={() => {
                                api.put(`balanceamento-metas/${meta.id}`, { valor: values[meta.id] }).then(response => {
                                    fetchData();
                                    showSuccess(response);
                                }).catch(error => {
                                    showError(error);
                                });
                            }}
                            type="number"
                            value={values[meta.id]}
                        />
                    </div>
                ))}
            </div>
        </Dialog>
    )
}